var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / PT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-PT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#FF2936",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    fill: "#128415",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 10.6666667,
    height: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1",
    stroke: "#FAF94F",
    strokeWidth: 1.33333333,
    mask: "url(#mask-2)",
    cx: 10.6666667,
    cy: 10,
    r: 3.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,8.34103775 C9.33333333,8.1526878 9.47670492,8 9.66031901,8 L11.6730143,8 C11.8536035,8 12,8.15192032 12,8.34103775 L12,10.6680579 C12,11.4036692 11.4081802,12 10.6666667,12 L10.6666667,12 C9.930287,12 9.33333333,11.4097862 9.33333333,10.6680579 L9.33333333,8.34103775 Z",
    id: "Rectangle-429",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,10.6666667 C11.0348565,10.6666667 11.3333333,9.70152317 11.3333333,9.33333333 C11.3333333,8.9651435 11.0348565,8.66666667 10.6666667,8.66666667 C10.2984768,8.66666667 10,8.9651435 10,9.33333333 C10,9.70152317 10.2984768,10.6666667 10.6666667,10.6666667 Z",
    id: "Oval-27",
    fill: "#1D50B5",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/PT.6e4a963de579fb878ae7df0874fad714.svg";
export { ForwardRef as ReactComponent };